import React, { Component } from "react";
import { components } from "react-select";
import { Row, Col, Image, Form, Card, Modal, Button, Container } from "react-bootstrap";
import BreadcrumbHeading from "../../breadcrumbs/BreadcrumbHeading";
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import axios, { post } from "axios";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../../utils/moduleGuard";

// /settings/organization-profile → "organization_profile" (see MODULE_ROUTES in
// moduleAccessGuard).
// module_key ONLY, never module_name: "Settings" is the shared sidebar group, and
// can() grants an action when ANY matched row allows it, so matching the group name
// would let a sibling Settings module's grant leak in.
const ORGANIZATION_PROFILE_MODULE = ["organization_profile"];

const ADDEDIT_ORGANIZATION_PROFILE = gql`
  mutation($params: addEditOrganisationProfile) {
    addEditOrganisationProfile(params: $params)
  }
`;

class SettingSection extends Component {
  constructor(props) {
    super(props);

    let organisation_name,
      address,
      mobile,
      hodmobile,
      principal,
      vice_principal,
      principlemobile,
      viceprinciplemobile,
      chairman,
      logo,
      hod = "";
    let organisation_nameValid,
      addressValid,
      formValid,
      mobileValid,
      principlemobileValid,
      hodmobileValid,

      viceprinciplemobileValid = false;

    if (props.getOrganisationProfile != null) {
      if (props.getOrganisationProfile.organisation_name != "") {
        organisation_name = props.getOrganisationProfile.organisation_name;
        organisation_nameValid = true;
      }

      if (props.getOrganisationProfile.principal != "") {
        principal = props.getOrganisationProfile.principal;

      }
      if (props.getOrganisationProfile.vice_principal != "") {
        vice_principal = props.getOrganisationProfile.vice_principal;

      }

      if (props.getOrganisationProfile.complete_address != "") {
        address = props.getOrganisationProfile.complete_address;
        addressValid = true;
      }

      if (
        (props.getOrganisationProfile.organisation_name != "") &
        (props.getOrganisationProfile.complete_address != "")
      ) {
        formValid = true;
      }

      if (props.getOrganisationProfile.contact_no != "") {
        mobile = props.getOrganisationProfile.contact_no;
        mobileValid = true;
      }

      if (props.getOrganisationProfile.hod_mobile != "") {
        hodmobile = props.getOrganisationProfile.hod_mobile;
        hodmobileValid = true;
      }

      if (props.getOrganisationProfile.principal_mobile != "") {
        principlemobile = props.getOrganisationProfile.principal_mobile;
        principlemobileValid = true;
      }

      if (props.getOrganisationProfile.vice_principal_mobile != "") {
        viceprinciplemobile =
          props.getOrganisationProfile.vice_principal_mobile;
        viceprinciplemobileValid = true;
      }
      if (props.getOrganisationProfile.chairman != "") {
        chairman = props.getOrganisationProfile.chairman;
      }

      if (props.getOrganisationProfile.logo != "") {
        logo = props.getOrganisationProfile.logo;
      }
      if (props.getOrganisationProfile.hod != "") {
        hod = props.getOrganisationProfile.hod;
      }
    }

    this.state = {
      breadcrumbsData: {
        Title: "Organization Profile",
      },
      modalShow: false,
      //form fields
      organizationname: organisation_name,
      organizationnamevalue: "",
      chairmenname: chairman,
      mobile: mobile,
      address: address,
      logo: logo,
      logo_filename: "Choose File",
      hod: hod,
      hodmobile: hodmobile,
      principle: principal,
      principlemobile: principlemobile,
      viceprinciple: vice_principal,
      viceprinciplemobile: viceprinciplemobile,
      formErrors: {
        organizationname: "",
        address: "",
        mobile: "",
        hodmobile: "",
        principlemobile: "",
        viceprinciplemobile: "",
      },
      organizationnameValid: organisation_nameValid,
      addressValid: addressValid,
      mobileValid: mobileValid,
      hodmobileValid: hodmobileValid,
      principlemobileValid: principlemobileValid,
      viceprinciplemobileValid: viceprinciplemobileValid,
      currentStep: 1,
      formValid: formValid,
      submitError: "",
      isUploading: false,
      isSaving: false,
      accessDeniedShow: false,
    };

    this.guard = attachModuleGuard(this, ORGANIZATION_PROFILE_MODULE);
  }

  // "Update" — the button stays visible and clickable. The grant is checked here,
  // before the form validation, so a role without is_edit is told they lack access
  // rather than being sent to fix a form they were never allowed to submit. This is
  // also the last gate before addEditOrganisationProfile.
  handleFormSubmit = (e) => {
    e.preventDefault();

    if (!this.guard.requireEdit()) return;

    console.log("Form submitted");
    console.log("Cookies2", Cookies.get("institutename"));
    console.log("institutionid2", Cookies.get("institutionid"));

    if (this.state.formValid) {
      let addEditOrganisationProfile = "";
      addEditOrganisationProfile = {
        organisation_name: this.state.organizationname,
        chairman: this.state.chairmenname,
        contact_no: this.state.mobile,
        complete_address: this.state.address,
        logo: this.state.logo,
        hod: this.state.hod,
        hod_mobile: this.state.hodmobile,
        principal: this.state.principle,
        principal_mobile: this.state.principlemobile,
        vice_principal: this.state.viceprinciple,
        vice_principal_mobile: this.state.viceprinciplemobile,
        institution_id: parseInt(Cookies.get("institutionid")),
        username: Cookies.get("username"),
      };
      this.setState({ isSaving: true });
      this.addeditorg(addEditOrganisationProfile).catch((error) => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          submitError: error.graphQLErrors.map((x) => x.message),
          isSaving: false,
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map((x) => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };
  addeditorg = async (params) => {
    await this.props.addeditorg({
      variables: {
        params,
      },
      update: (store, { data }) => {
        if (data.addEditOrganisationProfile) {
          this.setState({
            //currentStep: 5
            modalShow: true,
            isSaving: false,
          });

          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      },
    });
  };
  SetpageLoad = () => {
    console.log("setTimeout");
    this.setState({
      //currentStep: 1,
      modalShow: false,
    });
    window.location.reload(true);
  };
  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name == "logo") {
      // Picking a logo POSTs the file to /uploadLogo, so it's a write → is_edit.
      // The file input stays enabled; the upload is what gets stopped. Reset the
      // input so the rejected file isn't left sitting in it.
      if (!this.guard.requireEdit()) {
        e.target.value = "";
        return;
      }

      var file = e.target.files[0];
      let fileread = new FileReader();
      this.setState({
        logo_filename: "Uploading...",
        isUploading: true,
      });

      fileread.readAsDataURL(file);
      fileread.onload = async (e) => {
        try {
          const graphqlUri = process.env.REACT_APP_API_URL || "http://localhost:3008/graphql";
          const apiBase = graphqlUri.replace("/graphql", "");

          const response = await post(`${apiBase}/uploadLogo`, {
            file: e.target.result,
            filename: file.name,
          });

          if (response.data && response.data.file_url) {
            this.setState({
              logo: response.data.file_url,
              logo_filename: response.data.file_name,
            });
          }
        } catch (error) {
          console.error("Logo upload failed", error);
          this.setState({ logo_filename: "Choose File" });
        } finally {
          this.setState({ isUploading: false });
        }
      };
    } else {
      this.setState({ [name]: value }, () => {
        this.validateField(name, value);
      });
    }
  };
  selecthandleInputChange = (ename, evalue) => {
    console.log("selecthandleInputChange", this.props);
    const name = ename;
    const value = evalue;
    if (name == "organizationname") {
      this.setState({
        organizationnamevalue: { value: value, labl: "" },
      });
    }
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let organizationnameValid = this.state.organizationnameValid;
    let addressValid = this.state.addressValid;
    let mobileValid = this.state.mobileValid;
    let hodmobileValid = this.state.hodmobileValid;
    let principlemobileValid = this.state.principlemobileValid;
    let viceprinciplemobileValid = this.state.viceprinciplemobileValid;

    switch (fieldName) {
      case "organizationname":
        if (value.length == "") {
          organizationnameValid = false;
          fieldValidationErrors.organizationname =
            "organization Name Cannot Be Empty";
        } else {
          organizationnameValid = true;
          fieldValidationErrors.organizationname = "";
        }

        break;

      case "address":
        if (value.length == "") {
          addressValid = false;
          fieldValidationErrors.address = "Address Name Cannot Be Empty";
        } else {
          addressValid = true;
          fieldValidationErrors.address = "";
        }

        break;

      case "mobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");
        if (!pattern.test(value)) {
          mobileValid = false;
          fieldValidationErrors.mobile = "Invalid mobile";
        } else {
          mobileValid = true;
          fieldValidationErrors.mobile = "";
        }

        break;

      case "hodmobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");
        if (!pattern.test(value)) {
          hodmobileValid = false;
          fieldValidationErrors.hodmobile = "Invalid mobile";
        } else {
          hodmobileValid = true;
          fieldValidationErrors.hodmobile = "";
        }

        break;

      case "principlemobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");
        if (!pattern.test(value)) {
          principlemobileValid = false;
          fieldValidationErrors.principlemobile = "Invalid mobile";
        } else {
          principlemobileValid = true;
          fieldValidationErrors.principlemobile = "";
        }

        break;

      case "viceprinciplemobile":
        var pattern = new RegExp("^[6-9][0-9]{9}$");
        if (!pattern.test(value)) {
          viceprinciplemobileValid = false;
          fieldValidationErrors.viceprinciplemobile = "Invalid mobile";
        } else {
          viceprinciplemobileValid = true;
          fieldValidationErrors.viceprinciplemobile = "";
        }

        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        organizationnameValid: organizationnameValid,
        addressValid: addressValid,
        mobileValid: mobileValid,
        hodmobileValid: hodmobileValid,
        principlemobileValid: principlemobileValid,
        viceprinciplemobileValid: viceprinciplemobileValid,
      },
      this.validateForm
    );
  }
  validateForm() {
    this.setState({
      formValid:
        (this.state.organizationnameValid && this.state.addressValid) ||
        this.state.mobileValid ||
        this.state.hodmobileValid ||
        this.state.principlemobileValid ||
        this.state.viceprinciplemobileValid,
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" });
    }
  }

  render() {
    // is_view === 0 → the organisation's data is never rendered. The query that
    // fetches it is skipped in OrganizationProfile.jsx, so nothing is loaded either.
    // The page shell (navbar / sidebar / footer) comes from that page, so the user
    // can still navigate to modules they DO have.
    // (FIN, the style block, is declared further down inside render, so this early
    // return carries its own inline wrapper.)
    if (!this.guard.canView()) {
      return (
        <div
          style={{
            background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
            minHeight: "100vh",
            padding: "24px 28px",
            marginBottom: 100,
          }}
        >
          <AccessDeniedCard />
        </div>
      );
    }

    console.log("getOrganisationProfile", this.props.getOrganisationProfile);
    // Locations
    const Locations = [
      { value: 1, label: "Telangana" },
      { value: 2, label: "Andhra Pradesh" },
      { value: 3, label: "Chennai" },
    ];

    // Regions
    const Regions = [
      { value: 1, label: "Regions-1" },
      { value: 2, label: "Regions-2" },
      { value: 3, label: "Regions-3" },
      { value: 4, label: "Regions-4" },
    ];

    const DropdownIndicator = (props) => {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className="css-6q0nyr-Svg"
            >
              <path
                fill="currentColor"
                d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
              ></path>
            </svg>
          </components.DropdownIndicator>
        )
      );
    };

    const FIN = {
      wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
      card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" },
      cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
      iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
      titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
      title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
      subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
      content: { padding: "24px" },
      section: { background: "#fff", borderRadius: 12, padding: "20px 20px 8px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #eef2f7" },
      heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 },
      label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
      input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
      err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
      req: { color: "#dc2626" },
      btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "11px 38px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
    };

    return (
      <div style={FIN.wrapper} className="organization_profile_section">
        <Container fluid className="px-0">
            <div style={FIN.card}>
              {/* Header */}
              <div style={FIN.cardHeader}>
                <div style={FIN.iconWrapper}><i className="fal fa-building" /></div>
                <div style={FIN.titleText}>
                  <h5 style={FIN.title}>Organization Profile</h5>
                  <span style={FIN.subtitle}>Institute details &amp; branding</span>
                </div>
              </div>

              <div style={FIN.content}>
                {this.state.currentStep == 5 ? (
                  <p style={{ color: "#059669", fontWeight: 600 }}>User Saved successfully</p>
                ) : this.state.submitError ? (
                  <p style={{ color: "#dc2626" }}>{this.state.submitError}</p>
                ) : null}

                {/* Organization Details */}
                <div style={FIN.section}>
                  <p style={FIN.heading}><i className="fal fa-info-circle" />Organization Details</p>
                  <Row>
                    <Col lg={4} md={12} sm={12} className="mb-3">
                      <label style={FIN.label}>Organization Name <span style={FIN.req}>*</span></label>
                      <input style={FIN.input} type="text" placeholder="Organization Name" onChange={this.handleInputChange} autoComplete="off" name="organizationname" value={this.state.organizationname} maxLength={100} />
                      {this.state.formErrors.organizationname ? <span style={FIN.err}>{this.state.formErrors.organizationname}</span> : null}
                    </Col>
                    <Col lg={4} md={12} sm={12} className="mb-3">
                      <label style={FIN.label}>Chairman</label>
                      <input style={FIN.input} type="text" placeholder="Chairman" onChange={this.handleInputChange} autoComplete="off" name="chairmenname" value={this.state.chairmenname} maxLength={100} />
                    </Col>
                    <Col lg={4} md={12} sm={12} className="mb-3">
                      <label style={FIN.label}>Contact No</label>
                      <input style={FIN.input} type="phone" placeholder="Mobile No" onChange={this.handleInputChange} autoComplete="off" name="mobile" value={this.state.mobile} maxLength={10} />
                      {this.state.formErrors.mobile ? <span style={FIN.err}>{this.state.formErrors.mobile}</span> : null}
                    </Col>
                    <Col lg={8} md={12} sm={12} className="mb-3">
                      <label style={FIN.label}>Complete Address - Main Branch <span style={FIN.req}>*</span></label>
                      <textarea style={{ ...FIN.input, height: "auto", minHeight: 80, resize: "vertical" }} placeholder="Address" onChange={this.handleInputChange} autoComplete="off" name="address" value={this.state.address} maxLength={250} rows={3} />
                      {this.state.formErrors.address ? <span style={FIN.err}>{this.state.formErrors.address}</span> : null}
                    </Col>
                    <Col lg={3} md={8} sm={12} className="mb-3">
                      <label style={FIN.label}>Upload Logo</label>
                      <input style={{ ...FIN.input, paddingTop: 8 }} type="file" name="logo" onChange={this.handleInputChange} id="exampleFormControlFile1" />
                      <span style={{ fontSize: 12, color: "#64748b", marginTop: 3, display: "block" }}>{this.state.logo_filename}</span>
                    </Col>
                    <Col lg={1} md={4} sm={12} className="mb-3 d-flex flex-column">
                      <label style={FIN.label}>Preview</label>
                      <Image src={`https://support.rizee.in/files/${this.state.logo}`} width="60" height="60" alt="preview-img" style={{ borderRadius: 8, objectFit: "cover", border: "1px solid #e5e7eb" }} />
                    </Col>
                  </Row>
                </div>

                <div style={{ textAlign: "right", marginTop: 8 }}>
                  <button
                    style={{ ...FIN.btnPrimary, opacity: (this.state.isUploading || this.state.isSaving) ? 0.6 : 1, cursor: (this.state.isUploading || this.state.isSaving) ? "not-allowed" : "pointer" }}
                    onClick={this.handleFormSubmit}
                    disabled={this.state.isUploading || this.state.isSaving}
                  >
                    {this.state.isUploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" style={{ marginRight: 6 }}></span> Uploading...
                      </>
                    ) : this.state.isSaving ? (
                      <>
                        <span className="spinner-border spinner-border-sm" style={{ marginRight: 6 }}></span> Saving...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save" /> Save
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Container>
        <Modal
          {...this.props}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
          size="md"
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">Status</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Row className="text-center">
              <Col xl={12} lg={12} md={12}>
                <i className="fal fa-check-circle fa-4x mb-3 text-success" />
                <h6>
                  Saved
                  <br /> Successfully
                </h6>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Shown instead of saving / uploading a logo when is_edit is missing. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    );
  }
}
export default withRouter(
  compose(
    graphql(ADDEDIT_ORGANIZATION_PROFILE, {
      name: "addeditorg",
    })
  )(SettingSection)
);
